import { Box, Flex, Grid, Group, Loader, Text, UnstyledButton } from '@mantine/core';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../config/RoutesName';
import { useGlobalContext } from '../../context/global-context';
import { useGetCartItems } from '../../services/cart-item/cart-item.service';
import { useGetRestaurantMenuItems } from '../../services/restaurant/menu-items/restaurant-menu-items.service';
import { IGetCartItems, IMenuItem, IVariant } from '../../typescript/interfaces/cart-item.interface';
import NewItemAcordion from '../AddCart/NewItemAcordion';
import FoodItemsCard from './FoodItemsCard';
import { FoodItemsContainerScrollArea, useFoodItemsContainerStyles } from './styles';
import { useCartContext } from '../../context/cart-context.tsx';

// export interface IMenuItems {
//   menu_item_id: number;
//   restaurant_id: number;
//   name: string;
//   price: number;
//   unit_price: number;
//   calories: number;
//   is_in_cart: boolean;
//   is_available_now: boolean;
//   description: string;
//   category_id: number;
//   category_name: string;
//   created_at: string;
//   diet: Diet;
//   image_url: string;
// }

export interface Diet {
  diet_id: number;
}

type Props = {
  category: number;
  restaurantInfo: {
    restaurantId: number;
    restaurantName: string;
    rating: number;
    ratingCount: number;
    openingHours: string;
    fullAddress: string;
  };
  setCategory: React.Dispatch<
    React.SetStateAction<{
      name: string;
      id: number;
    }>
  >;
  foodItemRefs: any;
  menuItems: IMenuItem[];
  isMenuItemsSuccess: boolean;
  isMenuItemsLoading: boolean;
  isMenuItemsFetchingNextPage: boolean;
  isMenuItemsDisabled: boolean;
};

const FoodItemsContainer: FC<Props> = ({
  restaurantInfo,
  category,
  setCategory,
  foodItemRefs,
  menuItems,
  isMenuItemsSuccess,
  isMenuItemsLoading,
  isMenuItemsFetchingNextPage,
  isMenuItemsDisabled,
}) => {
  const navigate = useNavigate();
  const { cookies } = useGlobalContext();
  const { classes } = useFoodItemsContainerStyles();
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const [variants, seIVariants] = useState<Record<string, IVariant[]>>({});
  const _addToCardIsLoading = useState(false);
  const [addToCardIsLoading] = _addToCardIsLoading;
  // const foodItemRefs = useRef<Array<HTMLDivElement | null>>([]);

  const {
    data: cartData,
    isError: isCartError,
    error,
    isSuccess: isCartSuccess,
    isLoading: isCartLoadng,
    refetch,
    isFetched,
  } = useCartContext();

  useEffect(() => {
    if (isCartSuccess) {
      const cartItemsRes = cartData?.data as IGetCartItems;
      let _variants: Record<string, IVariant[]> = {};

      cartItemsRes?.cart_items?.forEach((_item) => {
        let addonsTotal = 0;
        const addonLevelIds: IVariant['addon_level_ids'] = [];
        let addons: IVariant['addons'] = {};
        _item?.menu_item?.item_choices?.forEach((_item) => {
          _item?.addon_levels?.forEach((addonLevel) => {
            if (addonLevel?.is_in_cart) {
              addonsTotal += addonLevel?.amount;
              addonLevelIds.push(addonLevel?.addon_level_id);
              addons = {
                ...addons,
                [addonLevel?.addon_level_id]: {
                  addonId: addonLevel?.addon_level_id,
                  amount: addonLevel?.amount,
                  name: `${_item?.name} (${addonLevel?.name})`,
                },
              };
            }
          });
        });
        // const currMenuItemIndex = Object.keys(_variants).findIndex(
        //   (key) => key === String(_item?.menu_item?.menu_item_id),
        // );
        const currMenuItemId = String(_item?.menu_item?.menu_item_id) as keyof typeof _variants;
        _variants = {
          ..._variants,
          [currMenuItemId]: [
            ...(_variants?.[currMenuItemId] ?? []),
            {
              id: _item?.cart_item_id,
              quantity: _item?.quantity,
              addonsTotal,
              unitPrice: _item?.total_amount / _item?.quantity,
              addon_level_ids: addonLevelIds,
              addons,
            },
          ],
        };
      });

      // _variants[1](v);

      seIVariants(_variants);
    }
  }, [isCartSuccess]);

  const scrollHandler = async (e: any) => {
    const container = e.target;
    const containerTop = container.getBoundingClientRect().top;

    let closestItem: any = null;
    let minDistance = Infinity;

    foodItemRefs.current.forEach((ref: any) => {
      if (ref) {
        const rect = ref.getBoundingClientRect();
        const distance = Math.abs(rect.top - containerTop);
        if (distance < minDistance) {
          minDistance = distance;
          closestItem = ref;
        }
      }
    });

    const newCategoryId = closestItem?.dataset?.categoryId && JSON.parse(closestItem?.dataset?.categoryId);
    if (newCategoryId?.id && newCategoryId?.id !== category) {
      setCategory(newCategoryId);
    }

    // Fetch next page if needed
    // const totalHeight = container.clientHeight + container.scrollTop;
    // if (totalHeight >= container.scrollHeight - 50 && !isFetching && !isLoading && hasNextPage && !isRefetchError) {
    //   fetchNextPage();
    // }
  };

  const scrollToCategory = (categoryId: number) => {
    const targetItem = foodItemRefs.current.find((ref: any) => {
      const refCategory = ref?.dataset?.categoryId;
      if (refCategory) {
        const parsed = JSON.parse(refCategory);
        return parsed.id === categoryId;
      }
      return false;
    });

    if (targetItem) {
      targetItem.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  // useEffect(() => {
  //   if (category) {
  //     scrollToCategory(category);
  //   }
  // }, [category]);

  return (
    <FoodItemsContainerScrollArea className='FoodItemsContainerScrollArea' onScroll={scrollHandler}>
      <Grid p={0} m={0}>
        {isMenuItemsSuccess && (isCartSuccess || isCartError) ? (
          <React.Fragment>
            {menuItems?.map((d, index: number) => (
              <Grid.Col
                key={index}
                xs={12}
                ref={(el) => (foodItemRefs.current[index] = el)}
                data-category-id={JSON.stringify({ id: d.category_id, name: d.category_name })}>
                {d.category_name && (
                  <Text fw={600} mt={10} c='magenta.9'>
                    {d.category_name}
                  </Text>
                )}

                {(isCartSuccess || isCartError) && (
                  <NewItemAcordion
                    restaurantInfo={restaurantInfo}
                    foodInfo={d}
                    type='regular'
                    variants={variants[String(d?.menu_item_id)]}
                    _addToCardIsLoading={_addToCardIsLoading}
                    disabled={isMenuItemsDisabled || !d?.is_available_now}
                  />
                )}
                {/* <FoodItemsCard type='regular' data={d} restaurantInfo={restaurantInfo} /> */}
              </Grid.Col>
            ))}
          </React.Fragment>
        ) : null}
        {isMenuItemsLoading || isMenuItemsFetchingNextPage || isCartLoadng ? (
          <>
            {Array(2)
              .fill(0)
              .map((_, index) => (
                <Grid.Col key={index} xs={12} className={classes.gridCol}>
                  <FoodItemsCard type='loading' />
                </Grid.Col>
              ))}
          </>
        ) : null}
      </Grid>
      {+cookies['cart-item-count'] || cartData?.data?.items_count ? (
        <Flex justify='center' mt={10} pos='relative'>
          <UnstyledButton
            disabled={addToCardIsLoading}
            className={classes.goToCartButton}
            onClick={() => {
              navigate(ROUTES.CART);
            }}
            pos='fixed'
            bottom={10}
            opacity={addToCardIsLoading ? 0.5 : 1}>
            <Flex justify='space-between' w='100%'>
              <Text lh={1}>Go To Cart</Text>
              <Text lh={1}>{`${cookies['cart-item-count'] ?? cartData?.data?.items_count} item | $ ${parseFloat(
                cookies['cart-item-price'] ?? cartData?.data?.price?.total_amount,
              ).toFixed(2)}`}</Text>
              {addToCardIsLoading && (
                <Group pos='absolute' top={0} left={0} w='100%' h='100%' position='center' bg='rgba(255,255,255,0.5)'>
                  <Loader size={20} color='#D61D4F' />
                </Group>
              )}
            </Flex>
          </UnstyledButton>
        </Flex>
      ) : null}
    </FoodItemsContainerScrollArea>
  );
};

export default FoodItemsContainer;
